import types from './types';

const INITIAL_STATE = {
    loading: false,
    error: ''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.GET_SLIDER_IMAGES:
            return {
                loading: true
            };
        case types.GET_SLIDER_IMAGES_SUCCESS:
            return {
                loading: false,
                sliderImages: action.payload
            };
        case types.GET_SLIDER_IMAGES_FAILURE:
            return {
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};
